import React, { useContext } from "react";
import VisibilityContext from "src/provider/state-manager/visibilityProvider";
import UserContext from "src/provider/state-manager/userProvider";
import AppInfoContext from "src/provider/state-manager/appInfoProvider";
import ApiCaller from "../interceptor";
import { endpoints, terms } from "src/provider/config/constant";
import { catchErrMsg, erroMessage } from "src/utils/utility";
import { getStudentByUserName } from "src/utils/helpers";
import {
  DeleteResultPayload,
  EditResultPayload,
  UploadResultPayload,
} from "../types";

const ApiContext = React.createContext<any>(null);

export const ApiProvider = (props: any) => {
  const { loader, notifier } = useContext(VisibilityContext);
  const { user, setUserProperty } = useContext(UserContext);
  const { info, setInfoProperty, setSelectedMember } =
    useContext(AppInfoContext);
  const { setFetchMembers } = useContext(AppInfoContext);

  async function signin(payload: any) {
    try {
      loader(true);
      const { data } = await ApiCaller.post("login", payload);
      loader(false);

      if (data.responseCode === "00") {
        await setUserProperty("profile", { ...user.profile, ...data?.profile });
        await setUserProperty("token", data.token);
        await getBasicAppInfo();

        return true;
      } else {
        //await getBasicAppInfo();
        notifier.show(data.message);
        return false;
      }
    } catch (err) {
      loader(false);
      notifier.show(erroMessage(catchErrMsg(err)));
      console.log({ err });
      return false;
    }
  }

  async function addMember(body: any) {
    try {
      loader(true);
      const { data } = await ApiCaller.post("addMember", body);
      loader(false);

      if (data.responseCode === "00") {
        return notifier.show("Member succesfully added!", "Success", "success");
      } else {
        notifier.show(data.message);
        return false;
      }
    } catch (err) {
      loader(false);
      notifier.show(erroMessage(catchErrMsg(err)));
      console.log({ err });
      return false;
    }
  }

  async function getBasicAppInfo() {
    try {
      loader(true);
      const { data } = await ApiCaller.get("basicAppInfo");
      loader(false);

      console.log({ response: data });
      if (data.responseCode === "00") {
        await setInfoProperty("basicAppInfo", { ...data.info });
      } else {
        notifier.show(data.message);
      }
    } catch (err) {
      loader(false);
      notifier.show(erroMessage(catchErrMsg(err)));
      console.log({ err });
    }
  }

  async function getResult(payload: any) {
    try {
      loader(true);
      const { data } = await ApiCaller.post("get-result", payload);
      loader(false);

      if (data.responseCode === "00") {
        const studentProfile = getStudentByUserName(info, payload.studentName);
        await setInfoProperty("result", {
          ...data,
          studentProfile,
          session: payload.session,
          term: payload.term,
        });
        return true;
      } else {
        notifier.show(data.message);
        return false;
      }
    } catch (err) {
      loader(false);
      notifier.show(erroMessage(catchErrMsg(err)));
      console.log({ err });
      return false;
    }
  }

  async function sendBroadcastMail(mailSubject: any, message: any) {
    try {
      loader(true);
      const { data } = await ApiCaller.post("/broadcastMail", {
        mailSubject,
        message,
      });
      loader(false);

      if (data.responseCode === "00") {
        notifier.show(data.message, null, "success");
      } else {
        notifier.show(data.message);
        return false;
      }
    } catch (err) {
      loader(false);
      notifier.show(erroMessage(catchErrMsg(err)));
      console.log({ err });
      return false;
    }
  }

  async function resetPassword(password: any) {
    try {
      loader(true);
      const { username } = user.profile;
      const { data } = await ApiCaller.post("/changePassword", {
        username,
        password,
      });
      loader(false);

      if (data.responseCode === "00") {
        notifier.show(data.message, null, "success");
        // console.log(data);
      } else {
        notifier.show(data.message);
        // console.log(data);
        return false;
      }
    } catch (err) {
      loader(false);
      notifier.show(erroMessage(catchErrMsg(err)));
      console.log({ err });
      return false;
    }
  }

  async function addResultComment(payload: any) {
    try {
      loader(true);
      let resultId;
      let resultType;

      if (info?.result?.resultID?.examId) {
        resultId = info.result.resultID.examId;
        resultType = "Exam";
      } else {
        resultId = info.result.resultID.testId;
        resultType = "Test";
      }

      const { data } = await ApiCaller.post("resultComment", {
        ...payload,
        resultId,
        resultType,
      });
      await getResult({
        studentClass: data?.updatedResult?.studentClass,
        studentName: data?.updatedResult?.studentName,
        session: data?.updatedResult?.session,
        term: data?.updatedResult?.term,
      });
      loader(false);

      if (data.responseCode === "00") {
        notifier.show(
          "Comment added successfully",
          "Success Response",
          "success"
        );
        await getBasicAppInfo();
        return true;
      } else {
        notifier.show(data.message);
        return false;
      }
    } catch (err) {
      loader(false);
      notifier.show(erroMessage(catchErrMsg(err)));
      console.log({ err });
      return false;
    }
  }
  async function deleteResult(payload: DeleteResultPayload) {
    try {
      loader(true);
      const { data } = await ApiCaller.post("delete-result", payload);
      loader(false);

      if (data.responseCode === "00") {
        notifier.show(
          "Result deleted successfully",
          "Success Response",
          "success"
        );
        setInfoProperty("result", {});
        return true;
      } else {
        notifier.show(data.message);
        return false;
      }
    } catch (err) {
      loader(false);
      notifier.show(erroMessage(catchErrMsg(err)));
      console.log({ err });
      return false;
    }
  }

  async function fetchMember(memberClass: any) {
    try {
      loader(true);
      const response = await ApiCaller.post("fetchMembers", { memberClass });
      loader(false);

      if (response.data.responseCode === "00") {
        setFetchMembers("allMembers", response.data.info);
      }
    } catch (err) {
      loader(false);
      console.log(err);
      notifier.show(erroMessage(catchErrMsg(err)));
    }
  }

  async function deleteMember(id: any) {
    try {
      loader(true);
      const response = await ApiCaller.post("/deleteMember", { id });
      loader(false);
      if (response.data.responseCode === "00") {
        setSelectedMember("");
        notifier.show("Successfully deleted a member!", "Success", "success");
        await getBasicAppInfo();
      } else {
        notifier.show(response.data.message);
        return false;
      }
    } catch (err) {
      loader(false);
      notifier.show(erroMessage(catchErrMsg(err)));
    }
  }

  async function editProfile(body: any, navigate: any) {
    try {
      loader(true);
      const response = await ApiCaller.post("/updateMember", body);
      loader(false);
      if (response.data.responseCode === "00") {
        await getBasicAppInfo();
        notifier.show(response.data.message, "Success", "success");

        setSelectedMember("");
        navigate("/dashboard/profile");
      } else {
        notifier.show(response.data.message);
      }
    } catch (err) {
      loader(false);
      notifier.show(erroMessage(catchErrMsg(err)));
      console.log({ err });
      return false;
    }
  }

  async function uploadResult(payload: UploadResultPayload) {
    try {
      loader(true);
      const { data } = await ApiCaller.post("upload-result", payload);
      loader(false);

      if (data.responseCode === "00") {
        notifier.show(
          `${payload.resultType} result succesfully saved`,
          "Success Response",
          "success"
        );
        return true;
      } else {
        notifier.show(data.message);
        return false;
      }
    } catch (err) {
      loader(false);
      notifier.show(erroMessage(catchErrMsg(err)));
      console.log({ err });
      return false;
    }
  }

  async function editResult(payload: EditResultPayload) {
    try {
      loader(true);
      const { data } = await ApiCaller.post("edit-result", payload);
      loader(false);

      if (data.responseCode === "00") {
        notifier.show(
          `${payload.resultType} result succesfully updated`,
          "Success Response",
          "success"
        );
        await getResult({
          studentClass: data?.updatedResult?.studentClass,
          studentName: data?.updatedResult?.studentName,
          session: data?.updatedResult?.session,
          term: data?.updatedResult?.term,
        });
        return true;
      } else {
        notifier.show(data.message);
        return false;
      }
    } catch (err) {
      loader(false);
      notifier.show(erroMessage(catchErrMsg(err)));
      console.log({ err });
      return false;
    }
  }

  const callActions = {
    signin,
    getBasicAppInfo,
    addMember,
    getResult,
    addResultComment,
    deleteResult,
    deleteMember,
    fetchMember,
    editProfile,
    sendBroadcastMail,
    resetPassword,
    uploadResult,
    editResult,
  };

  return (
    <ApiContext.Provider value={{ API: callActions }}>
      {props.children}
    </ApiContext.Provider>
  );
};

export default ApiContext;
